/**
 * Progress component
 * Simple progress bar component using Tailwind CSS
 */

import React from 'react'
import { cn } from '@/lib/utils'

export interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number
  max?: number
}

export const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, max = 100, ...props }, ref) => {
    const percentage = Math.min(100, Math.max(0, (value / max) * 100))

    return (
      <div
        ref={ref}
        className={cn('tagp-progress-container', className)}
        {...props}
        style={{
          position: 'relative',
          height: '8px',
          width: '100%',
          overflow: 'hidden',
          borderRadius: '9999px',
          backgroundColor: 'var(--stroke-light, #e5e7eb)',
          ...(props.style || {})
        }}
      >
        <div
          className="tagp-progress-bar"
          style={{ 
            height: '100%', 
            backgroundColor: 'var(--primary, #3b82f6)', 
            transition: 'width 300ms ease-in-out',
            width: `${percentage}%` 
          }}
        />
      </div>
    )
  }
)
Progress.displayName = 'Progress'
